firebird.controller('messageBannerCtrl', [
    '$rootScope',
    '$scope',
    'localizationService',
    'desktopNotificationService',
    function ($rootScope, $scope, localizationService, desktopNotificationService) {
        var self = this;

        self.state = 'hide';
        self.header = '';
        self.content = '';
        self.buttonText = localizationService.translate('COMMON.DISMISS_TEXT');
        self.persist = false;
        self.hideDismissBtn = false;
        self.key = null;
        self.isInCompactMode = false;

        self.dismissByClick = dismissByClick;

        $scope.$on('banner-message-show', onShow);
        $scope.$on('banner-message-dismiss', onDismiss);
        $scope.$on('enable-compact-mode', onCompactModeReceived);

        init();

        self.messages = {};

        ////////////////////////

        function init() {
            $rootScope.$broadcast('banner-ctrl-ready');
        }

        function onShow(evt, msg) {
            if (!msg.key) {
                msg.key = 'default';
            }
            if (!msg.priority) {
                msg.priority = 0;
            }

            save(msg);
        }

        function onDismiss(evt, opts) {
            if (!opts) {
                opts = {};
            }
            if (!opts.key) {
                opts.key = 'default';
            }
            remove(opts);
        }

        function onCompactModeReceived(e, data) {
            self.isInCompactMode = data;
        }

        function findMostPriorityMessage() {
            if (Object.keys(self.messages).length == 0) {
                return null;
            }
            var currentMessage = self.messages[Object.keys(self.messages)[0]];
            for (var key in self.messages) {
                var item = self.messages[key];
                if (item.priority > currentMessage.priority) {
                    currentMessage = item;
                }
            }
            return currentMessage;
        }

        function save(msg) {
            self.messages[msg.key] = msg;

            msg = findMostPriorityMessage();
            showBannerMessage(msg);
        }

        function remove(opts) {
            var msg = self.messages[opts.key];
            if (!msg) {
                return;
            }

            var forceDismiss = opts && opts.forceDismiss;
            if (msg.persist && !forceDismiss) {
                return;
            }

            delete self.messages[opts.key];

            msg = findMostPriorityMessage();
            if (msg) {
                showBannerMessage(msg);
            } else {
                dismissBannerMessage();
            }
        }

        function showBannerMessage(msg) {
            self.header = msg.header;
            self.content = msg.content;
            self.state = 'show';
            self.persist = msg.persist ? true : false;
            self.hideDismissBtn = msg.hideDismissBtn ? true : false;
            self.key = msg.key;
            if (self.isInCompactMode) {
                desktopNotificationService.show(self.header + ' ' + self.content, 'warning', null, function () {
                    $rootScope.$broadcast('enable-compact-mode', false);
                });
            }
            digest();
        }

        function dismissBannerMessage(evt, opts) {
            self.header = '';
            self.content = '';
            self.state = 'hide';
            self.persist = false;
            self.hideDismissBtn = false;
            self.key = null;
            digest();
        }

        function dismissByClick() {
            if (self.key == null) {
                return;
            }

            remove({
                key: self.key,
                forceDismiss: true
            });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
